import { render, staticRenderFns } from "./SingleCompete.vue?vue&type=template&id=30ac97a0&scoped=true&"
import script from "./SingleCompete.vue?vue&type=script&lang=js&"
export * from "./SingleCompete.vue?vue&type=script&lang=js&"
import style0 from "./SingleCompete.vue?vue&type=style&index=0&id=30ac97a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ac97a0",
  null
  
)

export default component.exports